<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="3">
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="关联采购单" span="3">
      {{ head.relatedPurchaseOrderHead.orderNo }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.relatedPurchaseOrderItem.commoditySnapshot"
              :commoditySpec="
                scope.row.relatedPurchaseOrderItem.commoditySpecSnapshot
              "
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="商品信息"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <span style="font-size: 1.1em">{{
                scope.row.relatedPurchaseOrderItem.commoditySnapshot.name
              }}</span
              ><br />
              {{
                "规格：" +
                scope.row.relatedPurchaseOrderItem.commoditySpecSnapshot
                  .specName
              }}<br />
              {{
                "分类：" +
                scope.row.relatedPurchaseOrderItem.commoditySnapshot
                  .commodityCategory.name
              }}<br />
              {{
                "颜色：" +
                scope.row.relatedPurchaseOrderItem.commoditySnapshot.color
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="relatedPurchaseOrderItem.retailPrice"
          label="商品采购价"
          width="120"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount
              :amount="scope.row.relatedPurchaseOrderItem.retailPrice"
            ></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="退货数量"
          width="100"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.itemQuantity +
              scope.row.relatedPurchaseOrderItem.commoditySnapshot.unit
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityRetailTotalAmount"
          label="总采购价"
          width="120"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.commodityRetailTotalAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="出库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            {{ "待出库 " + scope.row.toBeOutputQuantity }}<br />
            {{ "出库中 " + scope.row.outputingQuantity }}<br />
            {{ "已出库 " + scope.row.completedOutputQuantity }}
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item span="1">
      <el-tooltip slot="label" placement="top">
        <div
          slot="content"
          style="line-height: 1.5em"
          v-html="$jsTool.warehousedMarkText()"
        ></div>
        <span>
          <i class="el-icon-question"></i>
          入库标识
        </span>
      </el-tooltip>
      <span v-fmtype="head.warehousedMark ? 'success' : 'warning'">{{
        head.warehousedMark ? "已入库" : "未入库"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item span="2">
      <el-tooltip slot="label" placement="top">
        <div
          slot="content"
          style="line-height: 1.5em"
          v-html="$jsTool.paidMarkText()"
        ></div>
        <span>
          <i class="el-icon-question"></i>
          付款标识
        </span>
      </el-tooltip>
      <span v-fmtype="head.paidMark ? 'success' : 'warning'">{{
        head.paidMark ? "已付款" : "未付款"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总采购价：
        <FmAmount :amount="head.commodityRetailTotalAmount"></FmAmount>
        ）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="收款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          收款进度：
          <span
            v-fmtype="
              $jsTool.getFundCollectProgressType(head.fundCollectProgressEnum)
            "
          >
            {{ head.fundCollectProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待收：<FmAmount :amount="head.toBeCollectAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          收款中：<FmAmount :amount="head.collectingAmount"></FmAmount
          >，已收款：<FmAmount :amount="head.completedCollectAmount"></FmAmount
          >，收款优惠：<FmAmount
            :amount="head.collectDisCountAmount"
          ></FmAmount>
        </div>
        <div class="fm-flex">
          全部收款时间：<span
            v-fmtype="head.fullCollectTime ? '' : 'warning'"
            >{{ head.fullCollectTime || "暂无" }}</span
          >
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="出库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          出库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityOutputProgressType(
                head.commodityOutputProgressEnum
              )
            "
          >
            {{ head.commodityOutputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">待出库：{{ head.toBeOutputQuantity }}</div>
        <div class="fm-flex">
          出库中：{{ head.outputingQuantity }}，已出库：{{
            head.completedOutputQuantity
          }}
        </div>
        <div class="fm-flex">
          全部出库时间：<span v-fmtype="head.fullOutputTime ? '' : 'warning'">{{
            head.fullOutputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="3">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebPurchaseReturnOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      return this.showOrderInfo && this.showOrderInfo.itemList
        ? this.showOrderInfo.itemList
        : [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseReturnOrder:NeedApproval",
        "Order:PurchaseReturnOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseReturnOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseReturnOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.purchaseReturnOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/PurchaseReturnOrderInfo.vue